import { Helmet } from "react-helmet";
export function Meta({
  title,
  description,
}: {
  title: string;
  description: string;
}): JSX.Element {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
}

export default Meta;
